import styled, { css } from 'styled-components';

import { mediaSize, theme } from '../../styles';
import { Container as C } from '../../components/ui-helpers';


export const ContentRight = styled.div`
  width: calc(100% - 230px);
  margin-left: 230px;
  transition: all 0.2s;
`;

export const ContentChildren = styled.div`
  padding: 30px 35px 0 35px;
`;

export const Container = styled(C)`
  display: flex;

  .ant-layout-sider {
    background: ${theme.colors.darkColor};
  }

  .ant-layout-sider-trigger {
    width: 230px !important;
    background: ${theme.colors.backgroundDarkSilver};
  }

  ${({ collapsed }) => collapsed
    && css`
      ${ContentRight} {
        width: calc(100% - 60px);
        margin-left: 60px;
      }

      .ant-layout-sider-trigger {
        width: 60px !important;
      }
  `}

  @media (max-width: ${mediaSize.desktop}) {
    ${ContentRight} {
      width: 100%;
      margin-left: unset;
    }
  }
`;

export const MobileOverlay = styled.div`
  display: block;
  position: fixed;
  background-color: rgba(0,0,0,0.3);
  height: 100%;
  width: 100%;
  z-index: 300;
`;



// WEBPACK FOOTER //
// ./src/layouts/main/styles.js